import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

// variant: primary | outline | ghost | danger
export function Button({ variant = 'outline', size, icon, loading, children, className = '', ...props }) {
  const classes = ['crm-btn', `crm-btn-${variant}`, size === 'sm' ? 'crm-btn-sm' : '', className].filter(Boolean).join(' ');
  return (
    <button className={classes} disabled={loading || props.disabled} {...props}>
      {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : icon && <FontAwesomeIcon icon={icon} />}
      {children}
    </button>
  );
}

export function IconButton({ icon, label, className = '', ...props }) {
  return (
    <button className={`crm-icon-btn ${className}`} title={label} aria-label={label} {...props}>
      <FontAwesomeIcon icon={icon} />
    </button>
  );
}

export default Button;
